/**
 * Each shell app's strip entry: its name, a short subtitle (the expanded strip shows it under the
 * name, the collapsed strip's tooltip shows both), and its Font Awesome icon.
 */
import {
  faAddressBook,
  faBookAtlas,
  faDiceD20,
  faFileLines,
  faGear,
  faIdCard,
  faMap,
  faPeopleGroup,
  faRobot,
  faTowerBroadcast,
  faUsers,
  type IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import type { RailApp } from "../railState";

export type StripApp = { label: string; subtitle: string; icon: IconDefinition };

export const STRIP_APPS: Record<RailApp, StripApp> = {
  director: { label: "Director", subtitle: "Scenes, banners, cues", icon: faTowerBroadcast },
  encounters: { label: "Encounters", subtitle: "Scenes and maps", icon: faMap },
  roster: { label: "Roster", subtitle: "Pilots and mechs", icon: faUsers },
  settings: { label: "Settings", subtitle: "Seats and the room lock", icon: faGear },
  pilot: { label: "My pilot", subtitle: "Your license and build", icon: faIdCard },
  mech: { label: "My mech", subtitle: "Your frames and loadouts", icon: faRobot },
  squad: { label: "Squad", subtitle: "Your lance's builds", icon: faPeopleGroup },
  dice: { label: "Dice", subtitle: "Skill checks", icon: faDiceD20 },
  compendium: { label: "Compendium", subtitle: "Rules and gear library", icon: faBookAtlas },
  codex: { label: "Codex", subtitle: "People, places, factions", icon: faAddressBook },
  cheatsheet: { label: "Cheatsheet", subtitle: "Rules quick reference", icon: faFileLines },
};

/** The accessible name of an app's strip button: name and subtitle. */
export const stripAppName = (app: RailApp) => `${STRIP_APPS[app].label} — ${STRIP_APPS[app].subtitle}`;
